import React, { useReducer } from 'react';
import TicketContext from './ticketContext';
import TicketReducer from './ticketReducer';
import api from '../../api/api';
import {
    GET_TICKETS,
    CREATE_TICKET,
    GET_TICKET,
    UPDATE_TICKET,
    CLEAR_STATE,
    SET_LOADING,
    GET_NOTIFICATIONS_TICKETS,
    UPDATE_TICKET_LIST,
    UPDATE_LIST,
    CLEAR_SNACKBARS,
} from '../types';
import { HEADERS } from '../../constants/headers';
import { ApiV2 } from 'src/api/apiv2';
import { AWS_S3 } from 'src/constants/crm/aws';
import axios from 'axios';
import { handleError } from '../utils/handleError';

const TicketState = (props) => {
    const initialState = {
        tickets: [],
        ticket: {},
        notificationTickets: [],
        loading: false,
        error: null,
        success: null,
        count: null,
    };

    const [state, dispatch] = useReducer(TicketReducer, initialState);

    const updateNotificationTickets = async (notificationId) =>
        dispatch({ type: UPDATE_LIST, payload: notificationId });

    const updateList = async (ticket) =>
        dispatch({ type: UPDATE_TICKET_LIST, payload: ticket });

    const getTicketsRockstar = async (isRead) => {
        setLoading();

        try {
            const res = await api.post(
                `/tickets/rockstar`,
                { isRead },
                HEADERS()
            );
            dispatch({
                type: GET_NOTIFICATIONS_TICKETS,
                payload: res.data.data,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Get Ticket
    const getTicket = async (ticketId) => {
        clearTicketState();
        setLoading();
        try {
            const res = await api.get(`/tickets/${ticketId}`, HEADERS());
            dispatch({ type: GET_TICKET, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Create Ticket
    const createTicket = async (ticket) => {
        clearTicketState();
        setLoading();
        try {
            const { file } = ticket;

            if (file) {
                const { type, name: fileName } = file;

                const uploadConfig = await api.post(
                    '/uploads/image',
                    { type, fileName },
                    HEADERS()
                );

                const { data } = uploadConfig;
                const { url, key } = data;
                await axios.put(url, file, {
                    headers: {
                        'Content-Type': file?.type || null,
                    },
                });

                ticket.image = `${AWS_S3}${key}`;
            }

            const res = await ApiV2.post(
                `/tickets/create`,
                { ...ticket },
                HEADERS()
            );
            dispatch({ type: CREATE_TICKET, payload: res.data.data });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Update Ticket
    const updateTicket = async (ticket, ticketId) => {
        setLoading();
        try {
            const length = ticket.media?.length || 0;

            let mediaAuxiliar = [];
            for (let i = 0; i < length; i++) {
                const currentMedia = ticket.media[i];
                const { type, name: fileName } = currentMedia;

                const response = await api.post(
                    '/uploads/image',
                    {
                        type,
                        fileName,
                    },
                    HEADERS()
                );
                const { data } = response;
                const { url, key } = data;

                await axios.put(url, currentMedia, {
                    headers: { 'Content-Type': type },
                });

                mediaAuxiliar.push(`${AWS_S3}${key}`);
            }
            ticket.media = mediaAuxiliar;

            const res = await ApiV2.put(
                `/tickets/update/${ticketId}`,
                { ...ticket },
                HEADERS()
            );
            dispatch({
                type: UPDATE_TICKET,
                payload: res.data.data,
                successMessage: 'Tickets.Updated',
            });

            setSnackbarInterval();
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    //Clear State
    const clearTicketState = () => dispatch({ type: CLEAR_STATE });

    //Set Loading
    const setLoading = () => dispatch({ type: SET_LOADING });

    const searchTicketsByFilters = async (filters) => {
        setLoading();
        try {
            const res = await api.post(
                `/tickets/search`,
                { ...filters },
                HEADERS()
            );

            dispatch({
                type: GET_TICKETS,
                payload: res.data.results,
                count: res.data.pagination.total,
            });
        } catch (error) {
            dispatch(handleError(error));
        }
    };

    const clearSnackbars = () =>
        dispatch({
            type: CLEAR_SNACKBARS,
        });

    const setSnackbarInterval = () => setTimeout(() => clearSnackbars(), 1000);

    return (
        <TicketContext.Provider
            value={{
                ...state,
                createTicket,
                getTicketsRockstar,
                getTicket,
                updateTicket,
                clearTicketState,
                setLoading,
                updateNotificationTickets,
                updateList,
                searchTicketsByFilters,
            }}
        >
            {props.children}
        </TicketContext.Provider>
    );
};

export default TicketState;
